import React from "react";
import { Typography } from "@material-tailwind/react";
import { CubeTransparentIcon } from "@heroicons/react/24/solid";
import { t } from "i18next";

/**
 * Composant pour afficher un message lorsqu'aucun flexible n'est disponible
 */
export default function EmptyHosesState() {
  return (
    <div className="text-center p-8 bg-gray-50 rounded-lg border border-dashed border-gray-300">
      <CubeTransparentIcon className="h-12 w-12 mx-auto text-gray-400 mb-3" />
      <Typography variant="h6" className="text-gray-600 mb-2">
        {t("workorder:hoses:noHose")}
      </Typography>
    </div>
  );
} 